<div>

    <!-- Header -->
    <h3 mat-dialog-title>
        <span translate>Already have a code?</span>
    </h3>

    <!-- Body -->
    <mat-dialog-content>
        <div translate>Enter the email address to which the code was sent and the code.</div>

        <!-- We have a margin-bottom of 1px because of a weird issue with a scrollbar -->
        <tyl-form-field style="width:350px; padding-top: 10px; margin-bottom: 1px;" label="Email Address">
            <input matInput id="inputEmailAddress" name="inputEmailAddress" [maxlength]="V10 == true ? 500 : 75"
                [(ngModel)]="verifyEmail" [emailFormat]="true" #email />
        </tyl-form-field>

        <tyl-form-field style="width:350px; padding-top: 10px; margin-bottom: 1px;" label="Code">
            <input matInput id="inputVeificationCode" name="inputVeificationCode" [maxlength]="6"
                [(ngModel)]="verifyCode" #code />
        </tyl-form-field>
    </mat-dialog-content>


    <!-- Footer -->
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button image="next arrow yellow.png" label="Submit" (clickEvent)="modalInstanceNextClick()">
            </tyl-button>
            <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="modalInstanceCancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
</div>